/* Reana Foods – header mobile menu (migrated from header Custom Liquid). */
if (!customElements.get('reana-header')) {
  class ReanaHeader extends HTMLElement {
    connectedCallback() {
      this.menu = this.querySelector('[data-reana-mobile-menu]');
      this.button = this.querySelector('[data-reana-menu-toggle]');
      if (!this.menu || !this.button) return;

      this.breakpoint = 850;
      this.onToggle = () => (this.menu.classList.contains('open') ? this.close() : this.open());
      this.onResize = () => { if (window.innerWidth > this.breakpoint) this.close(); };
      this.onKeyup = (e) => { if (e.key === 'Escape' && this.menu.classList.contains('open')) { this.close(); this.button.focus(); } };

      this.button.addEventListener('click', this.onToggle);
      this.menu.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => this.close()));
      window.addEventListener('resize', this.onResize);
      this.addEventListener('keyup', this.onKeyup);
      this.setLinksFocusable(false);
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.onResize);
    }

    setLinksFocusable(state) {
      this.menu.querySelectorAll('a, button').forEach((el) => {
        if (state) el.removeAttribute('tabindex');
        else el.setAttribute('tabindex', '-1');
      });
    }

    open() {
      this.menu.classList.add('open');
      this.button.classList.add('active');
      this.button.setAttribute('aria-expanded', 'true');
      this.button.setAttribute('aria-label', this.button.dataset.labelClose || 'Close menu');
      this.menu.setAttribute('aria-hidden', 'false');
      this.setLinksFocusable(true);
    }

    close() {
      this.menu.classList.remove('open');
      this.button.classList.remove('active');
      this.button.setAttribute('aria-expanded', 'false');
      this.button.setAttribute('aria-label', this.button.dataset.labelOpen || 'Open menu');
      this.menu.setAttribute('aria-hidden', 'true');
      this.setLinksFocusable(false);
    }
  }

  customElements.define('reana-header', ReanaHeader);
}
